import { State } from 'src/redux/reducer';
import { isLoaded, isPending, isRejected, shouldLoad } from 'src/redux/utils';

export const allSurveySelector = (state: State) => state.allSurvey.entities;
export const allSurveyStatusSelector = (state: State) => state.allSurvey.status;
export const allSurveyLoadedSelector = isLoaded(allSurveyStatusSelector);
export const shouldLoadAllListCompanySelector = shouldLoad(
  allSurveyStatusSelector,
);
export const allSurveyRejectedSelector = isRejected(allSurveyStatusSelector);
export const allSurveyPendingSelector = isPending(allSurveyStatusSelector);
